import component from './es-ES/component';
import globalHeader from './es-ES/globalHeader';
import menu from './es-ES/menu';
import pages from './es-ES/pages';
import pwa from './es-ES/pwa';
import settingDrawer from './es-ES/settingDrawer';
import settings from './es-ES/settings';

export default {
  'app.request.error.title.400': '404',
  'app.request.error.message.400': 'Página no encontrada',
  'app.request.error.403': 'Forbidden',
  'app.request.error.404': 'Not Found',
  'app.request.error.500': 'Internal Server Error',
  'app.request.error.502': 'Bad Gateway',
  'app.request.error.503': 'Service Unavailable',
  'app.request.error.504': 'Gateway Timeout',
  'app.request.error-request': '¡Solicitud de error!',
  'app.category.review': 'Revisión',
  'app.legend': 'Leyenda',
  'app.legend.independent_care': 'Cuidado Independiente',
  'app.legend.acute_care': 'Cuidados Agudos',
  'app.legend.basic_care': 'Cuidado Basico',
  'app.legend.requires_exp': 'Requiere Explicación',
  'app.legend.caution_care': 'Cuidado de la Precaución',
  'app.legend.condition_info': 'Información de Condición',
  'app.legend.notable_care': 'Cuidado Notable',
  'app.legend.required_info': 'Información Requerida',
  'app.estimate_cost': 'Costo estimado',
  'app.per_hour_commonapp': 'por hora',
  'app.estimate_cost_commonapp': 'Tarifa por hora estimada',
  'app.estimate_cost.quote-id': 'ID de Cotización',
  'app.estimate_cost.secondary': 'Cotización secundaria',
  'app.estimate_cost.secondary_minamalCare': 'Otra persona del hogar - requiere cuidados mínimos',
  'app.estimate_cost.secondary_minamalCare_commonapp': 'NOTE: PRICING FOR CARE RECIPIENT 1',
  'app.estimate_cost.contagion_cost': 'Costo estimado de contagio',
  'app.estimate_cost.contagion_note': 'Nota: La tarifa regular se utilizará una vez que termine el estado de contagio.',
  'app.estimate_cost.note-1': 'Gracias por enviar su cotización.',
  'app.estimate_cost.note-2':
    'Consulte su correo electrónico para conocer el costo estimado de su cotización y el código de cotización único.',
  'app.estimate_cost.note-3':
    'Un representante de la agencia se comunicará con usted para revisar su cotización.',
  'app.estimate_cost.note-4': 'Para salir por favor cierre su navegador.',
  'app.estimate_cost.note-5': `Si no ve el correo electrónico en su bandeja de entrada en unos minutos, marque su carpeta “correo basura” o “spam”.
Marque el mensaje de correo electrónico como no basura o correo no deseado para que los correos electrónicos que se envíen desde esta dirección se trasladen automáticamente a su carpeta original.`,
  'app.estimate_cost.note-6': `Si aún no recibe un correo electrónico, escriba a info@homecarequote.com o llame al (678)-809-9200 explicando el problema. 
Responderemos a su solicitud lo antes posible.`,
  'app.estimate_cost.note-commonapp_6': `Si aún no recibe un correo electrónico, escriba a Info@MyHomeCareQuote.com explicando el problema. 
Responderemos a su solicitud lo antes posible.`,
  'app.estimate_cost.note-commonapp': "Si desea recibir una copia en PDF de esta cotización por correo electrónico, proporcione una dirección de correo electrónico.",
  'app.estimate_cost.note-commonapp1': "Nadie se pondrá en contacto con usted a menos que lo autorice.",
  'app.estimate_cost.sendMailButton': 'Enviar',
  'app.button.back': 'Atrás',
  'app.button.next': 'Próximo',
  'app.button.save_draft': 'Guardar borrador y completar la cotización más tarde',
  'app.button.ask_for_call': 'Pedir ayuda',
  'app.button.update.question': 'Guardar/Actualizar Nueva Respuesta',
  'app.modal.yes': 'Sí',
  'app.modal.no': 'No',
  'app.suggestion.noCommunication.content': 'You indicated that {name} is not aware that care is being explored. Is there currently no communication with {name} about care?',
  'app.suggestion.correct': 'Correct',
  'app.suggestion.notCorrect': 'Not correct',
  'app.reassess.confirm.question': 'Are all of the answers shown above still accurate?',
  'app.reassess.confirm.yes': 'Yes, keep these answers and continue',
  'app.reassess.confirm.no': 'No, I need to make changes',
  'app.reassess.confirm.required': 'Please confirm whether the answers above are still accurate.',
  'app.reassess.previousAnswer': 'Previous answer',
  'app.contactMethod.needPhone': 'Please add a phone number or choose another contact method.',
  'app.contactMethod.needEmail': 'Please add an email address or choose another contact method.',
  'app.modal.sameAsRename.title': 'New contact added',
  'app.modal.sameAsRename.content': 'This contact is also used in other roles. Do you want to update them with new contact info?',
  'app.modal.sameAsRename.yes': 'Yes, update',
  'app.modal.sameAsRename.no': 'No, keep the previous person',
  'app.address.entered': 'You entered',
  'app.address.suggested': 'Suggested',
  'app.address.zipNotFound': "We couldn't find ZIP code {zip}. Please check it.",
  'app.address.streetNotFound': "We couldn't verify this street in ZIP code {zip}.",
  'app.address.streetNotFoundShort': 'Street not found',
  'app.address.notFound': 'Not found',
  'app.address.useSuggested': 'Use suggested',
  'app.address.keepEntered': 'Keep what I entered',
  'app.address.confirmCorrect': 'Yes, this is correct',
  'app.address.edit': 'Edit address',
  'app.modal.ask.title': 'Solicite ayuda a la agencia',
  'app.modal.ask.call_name': 'Nombre',
  'app.modal.ask.call_phone': 'Número de teléfono',
  'app.modal.ask.button.cancel': 'Cancelar',
  'app.modal.ask.button.submit': 'Entregar',
  'app.modal.ask.contact': '¿Cuál es la mejor hora para contactar?',
  'app.modal.quote.title': 'Carga tu cotización',
  'app.modal.quote.button.new': 'Nueva cita',
  'app.modal.quote.button.continue': 'Continuar',
  'app.modal.quote.placeholder': 'Identificación de cita ...',
  'app.modal.quote.required-continue':
    'La cita estará desactualizada después de 3 meses. Podrá clave en la ID de cotización antigua para rellenar las cotizaciones antiguas, editar y crear la nueva cotización.',
  'app.modal.saveDraft.title': 'Guardar borrador y completar la cotización más tarde',
  'app.modal.pinStaff.title': 'Ingrese el PIN del personal',
  'app.modal.pinStaff.label': 'Staff PIN',
  'app.modal.relQuestion.title': 'Confirmación',
  'app.modal.relQuestion.pleaseSelect': 'POR FAVOR, SELECCIONE',
  'app.modal.relQuestionChoiceConfirmSelect': 'No seleccionó este servicio en la sección "{nameQuestion}". {p} ¿Desea seleccionarlo ahora?',
  'app.modal.relQuestionChoiceConfirmDeselect': 'Seleccionó este servicio en la pregunta "{nameQuestion}". {p} ¿Desea desmarcarlo?',
  'app.modal.confirmHeightWeight.content': 'Por favor, confirme que la información que ha introducido es correcta antes de continuar.',
  'app.modal.siblingQuote.note': 'Estás reevaluando la cita secundaria {segundoQuote}. La cita principal es {primaryQuote}.',
  'app.label.additionalPersonCommonApp': 'Seleccione la segunda atención domiciliaria.',
  'app.label.other.bathing': 'Por favor explique',
  'app.label.other': "Otros",
  'app.label.age': 'Edad',
  'app.label.animal': 'Perros, gatos, pájaros, cerdos, peces',
  'app.label.time': 'TIME',
  'app.label.selectAll': 'Selecciona todo lo que aplique',
  'app.label.contact_me_on_date': 'CONTÁCTAME EN FECHA',
  'app.label.transfers.height': 'Altura del destinatario del cuidado',
  'app.label.transfers.weight': 'Peso del destinatario del cuidado',
  'app.label.transfers.height.unit': '(pulgadas)',
  'app.label.transfers.weight.unit': '(lbs)',
  'app.label.transfers.select': 'Seleccione uno de los siguientes:',
  'app.label.transfers.option1': 'Asistencia parcial del receptor de atención ( puede ayudar a algunos con la transferencia )',
  'app.label.transfers.option2': 'Asistencia total del receptor de atención ( no puede ayudar en absoluto con la transferencia )',
  'app.label.generalConcernsAll.label': "Fumador",
  'app.label.generalConcernsAll.option1': 'Fuma dentro de la casa / auto',
  'app.label.generalConcernsAll.option2': 'Fuma fuera de la casa / auto',
  'app.label.email': 'Email',
  'app.lable.checkterm': "Acepto los ",
  'app.lable.term': "Términos y Condiciones",
  'app.lable.returnHomeCareQuote': "Volver a ",
  'app.minimalsHourNote': 'Please note the service hours you selected are less than the agency’s minimum hours, and higher hourly rates may apply. Please confirm your service hours selection.',
  'app.scollNote': 'Desplácese hacia abajo para obtener más opciones.',
  'app.modal.saveDraft_name': 'Nombre',
  'app.modal.saveDraft_phone': 'Número de teléfono',
  'app.modal.saveDraft_email': 'Email',
  'app.label.name': 'Nombre',
  'app.label.phone': 'Tel',
  'app.label.contact': 'Hora de contacto',
  'app.lable.checkboxContactEmail': "Me gustaría que la comunicación por correo electrónico se enviara a esta dirección de correo electrónico.",
 'app.tooltip.adl':"ADL - Las Actividades de la Vida Diaria (AVD) incluyen bañarse, vestirse, el aseo personal, el uso del baño, las transferencias, el apoyo para la continencia y la asistencia para comer o alimentarse.",
 'app.tooltip.adlNote':"ADL (Actividades de la vida diaria)", 
 'app.tooltip.iadlNote':"IADL (Actividades instrumentales de la vida diaria)",
 'app.tooltip.iadl':"IADL - Las Actividades Instrumentales de la Vida Diaria (AIVD) incluyen compañía, preparación de comidas, recordatorios de medicamentos, compras, diligencias y apoyo ligero en las tareas del hogar.",
  'app.modal.saveDraft.button.cancel': 'Cancelar',
  'app.modal.saveDraft.button.submit': 'Entregar',
  'app.modal.saveDraft.note': "Gracias por usar HomeCareQuote.",
  'app.modal.saveDraft.isCompleteQuoteLable': "¿Desea completar esta cita usted mismo en un momento posterior?",
  'app.modal.saveDraft.isContactLable': "¿Desea que un Representante de HomeCareQuote se comunique con usted para ayudarlo a completar su presupuesto?",
  'app.modal.saveDraft.isNoContact': 'Tenga en cuenta que esto finalizará su sesión HomeCareQuote. No recibirá más información o correspondencia de HomeCareQuote. Si desea comenzar una nueva cotización, visite nuestro sitio web para comenzar su proceso de cotización.',
  'app.modal.saveDraft.isYesCompleteQuote': 'Ingrese su correo electrónico para que se le pueda enviar una copia para completarla a su conveniencia.',
  'app.modal.saveDraft.isYesContact': 'Ingrese su información de contacto y una vez que desea ser contactado',
  'app.settings.powered-by': 'Energizado por HCQ',
  'app.settings.validate-required': 'Este campo no puede estar vacío.',
  'app.settings.validate-required-DOB': 'Por favor, rellene la fecha de nacimiento o la edad.',
  'app.settings.validate-required-Petcare': 'Por favor, rellene uno de ellos.',
  'app.settings.validate-required-zipcode': 'ZipCode is requeridas',
  'app.settings.validate-email': 'Por favor introduzca una dirección de correo electrónico válida.',
  'app.settings.validate-phone': 'El número telefónico es inválido.',
  'app.settings.validate-datetime': 'El tiempo no es válido. Formato MM/DD/YYYY HH:MM AM/PM (zona horaria ET, CT, PT, etc)',
  'app.settings.validate-time': 'El tiempo no es válido. Formato HH:MM AM/PM',
  'app.settings.validate-date': 'La fecha no es válida. Formato MM/DD/YYYY',
  'app.settings.validate-date-format': 'Formato MM/DD/YYYY',
  'app.settings.validate-date-format_CA': 'Formato YYYY/MM/DD',
  'app.settings.validate-datetime.feature': 'La fecha debe estar en el futuro.',
  'app.settings.validate-datetime.past': 'La fecha debe estar en el pasado.',
  'app.settings.validate-house-number': 'Incluya el número de la casa (p. ej., 22 Main St).',
  'app.settings.validate-date.placeholder': 'MM/DD/YYYY',
  'app.settings.validate-time.placeholder': 'HH:MM AM/PM',
  'app.settings.validate-time.placeholder_commonapp': 'HH:MM AM/PM TZ',
  'app.settings.validate-timezone.placeholder': 'TZ',
  'app.settings.validate-incorrect': 'Este campo es incorrecto',
  'app.settings.validate-confirm': 'Por favor, confirme su información',
  'app.settings.optional.explanation': 'Explicación',
  'app.settings.optional.reassessment': 'Cotización de reevaluación',
  'app.settings.reassessment': 'Cotización de reevaluación',
  'app.settings.reassessment.old-quote': 'La cotización ingresada',
  'app.settings.reassessment.existing-quote': '¿Código de cotización existente?',
  'app.settings.reassessment.submit': 'Enviar',
  'app.settings.reassessment.message-not-newest':
    'no es la versión más reciente, confirme la cotización que desea reevaluar.',
  'app.settings.select.placeholder': 'Seleccione uno',
  'app.settings.select.placeholder.street': 'Calle',
  'app.lable.confirmZipcode': "¿Quisiste decir que la dirección es:",
  'app.lable.notFoundAddress': "No se puede encontrar la dirección.",
  'app.lable.isHiddenPrice':"No incluir precios en esta cotización",
  'app.settings.select.placeholder.apt': 'Apartamento/Suite',
  'app.settings.select.placeholder.city': 'Ciudad',
  'app.settings.select.placeholder.state': 'Estado',
  'app.settings.select.placeholder.zip': 'Código postal',
  'app.settings.other': 'Otros/Notas/Detalles de adición (Utilice esta área para cualquier nota/información adicional)',
  'app.settings.uncertain': 'Incierta',
  'app.settings.more-information': 'Más información',
  'app.settings.description': 'Descripción',
  'app.settings.callName': 'Nombre',
  'app.settings.callPhone': 'Número de teléfono',
  'app.settings.validate-section': 'Por favor, rellene todas las preguntas requeridas',
  'app.settings.date.placeholder': 'MM/DD/YYYY',
  'app.settings.date.placeholderCA': 'YYYY/MM/DD',
  'app.settings.datetime.placeholder': 'MM/DD/YYYY HH:MM AM/PM (zona horaria ET, CT, PT, etc)',
  'app.settings.datetime.placeholderCA': 'YYYY/MM/DD HH:MM AM/PM (zona horaria ET, CT, PT, etc)',
  'app.settings.optional': '(opcional)',
  'app.label.personCare':'Los servicios de cuidado personal',
  'app.label.personCare1':'incluyen todos los acompañantes/cuidadores',
  'app.label.personCare2':'y las opciones que se muestran (seleccione todas las que correspondan):',
  'app.label.companion':'Los servicios de acompañante/cuidador',
  'app.label.companion1': 'incluyen las opciones que se muestran a continuación (seleccione todas las que correspondan).',
  'app.label.companion2': 'Los servicios de atención personal (actividades de la vida diaria) no están incluidos en el servicio de acompañante/cuidador.',
  'page.term.accept': 'Aceptar',
  'page.term.decline': 'Disminución',
  'page.term.notShowAgain': 'No mostrar de nuevo',
  'page.term.reviewAgain.button': 'Revise los términos y condiciones',
  'page.term.reviewAgain.title': 'No se aceptaron los términos y condiciones',
  'page.review.title': 'Compruebe la exactitud del presupuesto.',
  'page.review.title-estimate': 'Confirmación del presupuesto',
  'page.review.title-estimate-commonapp': 'Confirmación de tu cotización',
  'page.review.button.secondary': 'Imprimir cita secundaria',
  'page.review.button.print-price': 'Envíe su cotización',
  'page.review.button.print-price.quote-id': 'ID de Cotización',
  'page.review.button.create-new-quote': 'Crear una nueva cotización',
  'page.review.note': 'Si necesita editar/cambiar/corregir una respuesta, haga clic en el cuadro que desea actualizar.',
  'page.quota-exceeded.title': 'Cuota excedida',
  'page.quota-exceeded.description':
    'Se ha excedido la cuota de cotización. Por favor, extienda su plan.',
  'page.quota-exceeded.action': 'Renueva tu plan',
  'page.zipcode-error.description': "Actualmente, el servicio no está disponible en su área. Por favor, regrese e inténtelo de nuevo más tarde.",
  'page.zipcode-error.description2': "Por favor, regrese e inténtelo de nuevo más tarde.",
  'page.quota-expired.title': 'Plan Caducado',
  'page.quota-expired.description': 'El plan está vencido. Por favor renueve su plan.',
  'page.quota-expired.action': 'Renueva tu plan',
  'page.quota-invalid.title': 'Cuota inválida',
  'page.quota-invalid.description':
    'La ID de cotización proporcionada se encontró en nuestro sistema, pero no es válida para su uso. Por favor, intente nuevamente con otra identificación de cotización.',
  'page.quota-invalid.action': 'Contacto HomeCareQuote',
  'page.quota-invalid.action_Myhomecare': 'Contacto MyHomeCareQuote',
  'page.400.button.back': 'Atrás',
  'page.alert.expiration': 'Esta es la versión de demostración. Fecha de caducidad:',
  ...globalHeader,
  ...menu,
  ...settingDrawer,
  ...settings,
  ...pwa,
  ...component,
  ...pages,
};
